import React from "react"
import PropTypes from "prop-types"
import { Spinner } from "reactstrap"

const LoadingButton = ({ 
  children, 
  loading = false, 
  className = "", 
  disabled = false, 
  ...props 
}) => {
  return (
    <button
      className={`fbblack btn-light w-100 ${className}`}
      type="submit"
      disabled={loading || disabled}
      {...props}
    >
      {loading ? (
        <span className="d-flex align-items-center justify-content-center">
          <Spinner size="sm" className="me-2" />
          Processing...
        </span>
      ) : (
        children
      )}
    </button>
  )
}

LoadingButton.propTypes = {
  children: PropTypes.node.isRequired,
  loading: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
}

export default LoadingButton
